import { Injectable } from '@angular/core';
import {modulesSettings} from "../../../settings";
import {ModelSchema, Structures} from "octopus-model";

const settingsStructure: ModelSchema = new ModelSchema({
    rolesCanShowBannerInfo: Structures.array(),
});

@Injectable({
  providedIn: 'root'
})
export class GamecodeConfigurationService {

    public settings: { [p: string]: any };
    private readonly privateSettings: { [p: string]: any };


  constructor() {
      this.settings = this.privateSettings = settingsStructure.filterModel(
          modulesSettings.gamecode
      );
  }

    /**
     * if true, display header banner info
     */
    public get rolesCanShowBannerInfo(): string[] {
        return this.privateSettings.rolesCanShowBannerInfo;
    }

}
